import { IGetListParams } from './../../../base/base.service';
import { NewsService, INewsItem } from "../../../services";

class DashboardNewsController {
    private news: INewsItem[];
    private newsItemTypes = [
        {
            id: 2,
            name: 'Intern'
        },
        {
            id: 4,
            name: 'Klant'
        },
        {
            id: 1,
            name: 'Medewerker'
        },
    ];

    private all: boolean;

    constructor(private NewsService: NewsService, private $state: ng.ui.IStateService, private $stateParams: ng.ui.IStateParamsService) {
        "ngInject";
    }

    public $onInit = () => {

        if (this.$stateParams['newsall']) { 
            this.all = this.$stateParams['newsall'] == 'true' ? true : false;
        }
        this.getNews();
        //this.all = false;
    }

    public getType = (id) => {
        return this.newsItemTypes.find(t => t.id == id).name;
    }

    public setAll = () => {
        this.$state.go(".", { "newsall": this.all }, { notify: false });
        this.getNews();
    }

    public getNews = () => {
        const params = {
            limit: this.all ? 100 : 10,
            sortfield: 'createdDate',
            sortorder: 'desc',
            all: this.all
        }
        this.NewsService.all(params).then((news) => {
            this.news = news;
        })
    }

    addNewsItem() {
        
    }
}

export const dashboardNewsComponent = {
    controller: DashboardNewsController,
    template: require('./dashboardNews.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/news/dashboardNews.component.ts